import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {Form, Tab, Tabs} from "react-bootstrap";
import GroupList from "../../components/groupList";
import UnregisterGroupCounterparty from "../../components/unregisterGroupCounterparty";

const ListGroup = () => {
  const [tabIndex, setTabIndex] = useState(window.location.hash?.slice(1) ||"list");

  return (
    <>
      <Helmet>
        <title>Группы</title>
      </Helmet>
      <Tabs
        variant="underline"
        id="controlled-tab-example"
        activeKey={tabIndex}
        onSelect={key => {
          setTabIndex(key)
          window.location.hash = key
        }}
      >
        <Tab eventKey="list" title="Список" >
          <GroupList/>
        </Tab>
        <Tab eventKey="unregister" title="Неучтенные">
          <UnregisterGroupCounterparty/>
        </Tab>
      </Tabs>

    </>
  );
};

export default ListGroup;
